export default __webpack_public_path__ + "static/media/6.53efa118.jpg";